import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { compose } from "recompose";
import { withSnackbar } from "notistack";

import { GeoJSON, Pane, Popup } from "react-leaflet";

import { Amii } from "../../../services";
import { couleurZaDeploiement, zaAmiiVendeeInfo } from "../../../enums";

const ZaAmiiVN = ({
  optionSelectedConfigCarte,
  zoom,
  MIN_ZOOM_DISPLAY_AMII,
  MAX_ZOOM_DISPLAY_AMII,
  setIsLoading,
  enqueueSnackbar,
}) => {
  const [abortAmii, setAbortAmii] = useState(new AbortController());
  const [listeAmiiZa, setListeAmiiZa] = useState([]);

  const displayAmiiVendee = async () => {
    const listeAmiiZaTemp = [];

    abortAmii.abort();
    const abort = new AbortController();
    setAbortAmii(abort);

    Amii.getAmiiVendee(abort)
      .then(async responseListeAmii => {
        responseListeAmii.features.forEach(itemAmiiZa => {
          const styleAmii = {
            color: couleurZaDeploiement.ZAAMII,
            weight: 1,
            opacity: 1,
            fillColor: couleurZaDeploiement.ZAAMII,
            dashArray: "0",
            fillOpacity: 0.5,
          };

          listeAmiiZaTemp.push({
            item: itemAmiiZa,
            style: styleAmii,
          });
        });
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      })
      .finally(() => {
        setListeAmiiZa(listeAmiiZaTemp);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    displayAmiiVendee();

    return () => abortAmii.abort();
  }, []);

  return (
    <Pane name="amii" className="leaflet-amii-pane">
      {optionSelectedConfigCarte.ZONE_AMII &&
        zoom >= MAX_ZOOM_DISPLAY_AMII &&
        zoom <= MIN_ZOOM_DISPLAY_AMII &&
        listeAmiiZa.length > 0 &&
        listeAmiiZa.map(zaAmii => {
          const zaAmiiVendee = zaAmiiVendeeInfo.find(
            element => element.name === zaAmii.item.properties.NOM_COM,
          );
          return zaAmiiVendee ? (
            <GeoJSON key={zaAmii.item.properties.NOM_COM} data={zaAmii.item} style={zaAmii.style}>
              <Popup maxWidth={260} autoPan={false}>
                <div className="alignRight">
                  <img
                    className="logoMarcheTooltip"
                    src={zaAmiiVendee.logoSrc}
                    alt={zaAmiiVendee.name}
                  />
                </div>
                <div>
                  <p>
                    <span className="popupTitle popupTitleColor">{zaAmiiVendee.title}</span>
                    <br />
                    Sur {zaAmiiVendee.location}, les travaux de déploiement de la fibre sont assurés
                    par l’opérateur privé Orange (avec des offres commerciales de raccordement qui
                    sont aussi proposées par les autres opérateurs).
                  </p>
                  <p>
                    En savoir plus :{" "}
                    <a href={zaAmiiVendee.infoUrl} target="_blank" rel="noreferrer">
                      {zaAmiiVendee.infoName}
                    </a>
                    <br />
                    Connaitre son éligibilité :{" "}
                    <a
                      href="https://reseaux.orange.fr/couverture-reseaux/carte-de-couverture-fibre"
                      target="_blank"
                      rel="noreferrer"
                    >
                      reseaux.orange.fr
                    </a>
                  </p>
                </div>
              </Popup>
            </GeoJSON>
          ) : (
            <GeoJSON key={zaAmii.item.properties.NOM_COM} data={zaAmii.item} style={zaAmii.style}>
              <Popup maxWidth={260} autoPan={false}>
                <div>
                  <b>ZONE : {zaAmii.item.properties.ZONE}</b>
                  <br />
                  <b>Commune : {zaAmii.item.properties.NOM_COM}</b>
                  <br />
                  <b>Opérateur : {zaAmii.item.properties.OPERATEUR}</b>
                </div>
              </Popup>
            </GeoJSON>
          );
        })}
    </Pane>
  );
};

ZaAmiiVN.propTypes = {
  optionSelectedConfigCarte: propTypes.shape({
    LAYER_PLAN: propTypes.bool,
    LAYER_SAT: propTypes.bool,
    ALL_ZONES: propTypes.bool,
    SRO_DEP_201820: propTypes.bool,
    SRO_DEP_2021: propTypes.bool,
    SRO_DEP_2022: propTypes.bool,
    SRO_DEP_2023: propTypes.bool,
    SRO_OPEN: propTypes.bool,
    SRO_SOON: propTypes.bool,
    SRO_YEAR_N0: propTypes.bool,
    SRO_YEAR_N1: propTypes.bool,
    SRO_YEAR_N2: propTypes.bool,
    ZONE_RADIO: propTypes.bool,
    ZONE_AMII: propTypes.bool,
    ALL_STATUSES: propTypes.bool,
    IMB_RAC: propTypes.bool,
    IMB_ELIG: propTypes.bool,
    IMB_PROELIG: propTypes.bool,
    IMB_ETUDE: propTypes.bool,
    IMB_TRAVAUX_SECTEUR: propTypes.bool,
    IMB_TRAVAUX_RUE: propTypes.bool,
    IMB_DEMANDE: propTypes.bool,
    FTTE: propTypes.bool,
  }).isRequired,
  zoom: propTypes.number.isRequired,
  MAX_ZOOM_DISPLAY_AMII: propTypes.number.isRequired,
  MIN_ZOOM_DISPLAY_AMII: propTypes.number.isRequired,
  setIsLoading: propTypes.func.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(ZaAmiiVN);
